import React, { Component } from "react";
import { propertyUtil } from "views/Pma/PropertyUtil";
import { Link } from "react-router-dom";
import "./print.scss";

const OFFICE_ADDR_BR = /<br\s*\/?>/i;

function getOfficeAddressDisplayLines(officeAddressLine1, officeAddressLine2) {
  if (officeAddressLine1 == null || officeAddressLine1 === "") {
    return { line1: "", line2: officeAddressLine2 || null };
  }
  const raw = String(officeAddressLine1);
  if (!OFFICE_ADDR_BR.test(raw)) {
    return { line1: raw.trim(), line2: officeAddressLine2 || null };
  }
  const parts = raw.split(OFFICE_ADDR_BR);
  const line1 = (parts[0] || "").trim();
  const fromBr = parts
    .slice(1)
    .map((p) => p.trim())
    .filter(Boolean)
    .join(" ");
  return {
    line1: line1 || raw.replace(OFFICE_ADDR_BR, " ").trim(),
    line2: fromBr || officeAddressLine2 || null,
  };
}

class FirstLeftHeader extends Component {
  render() {
    const {
      logoURL,
      officeAddressLine1,
      officeAddressLine2,
      officeCity,
      officeState,
      officeZipcode,
      brokerageName,
      listgenUserID,
    } = this.props.agentData;
    const { filterBrokerage } = propertyUtil;
    const { hasLogo, currentArea, printVersion } = this.props;
    const { mlsAreaID } = currentArea;
    let useCommas2ndLine = false;
    if (listgenUserID === "102450" || listgenUserID === "115901") {
      useCommas2ndLine = true;
    }
    let editorOrPrint = printVersion ? "print-" : "editor-";
    let showButton = false;

    const { line1: officeAddrLine1, line2: officeAddrLine2 } =
      getOfficeAddressDisplayLines(officeAddressLine1, officeAddressLine2);

    return (
      <div className={`${editorOrPrint}first-left-header`}>
        {showButton && (
          <Link
            to={"/agent/details/ag/" + btoa(this.props.agentData.listgenUserID)}
            className="agent-info-edit-page-button"
          >
            <div className="agent-info-edit-page-button-text">
              Edit Agent Info
            </div>
          </Link>
        )}

        <div className="logo-address">
          {hasLogo && (
            <div className="agentLogo1-left">
              {logoURL !== null ? (
                <img alt="Agent Logo" src={logoURL} />
              ) : (
                <div className="missing-logo">
                  *** PLEASE UPLOAD AGENT LOGO ***
                </div>
              )}
            </div>
          )}
        </div>
        {mlsAreaID === "99" ? (
          <div className="return-address">
            <p>RETURN ADDRESS:</p>
            <p>PO Box 7621</p>
            <p>Salinas, CA 93908</p>
          </div>
        ) : brokerageName === "intero" ? (
          <div className="return-address">
            <p>{filterBrokerage(brokerageName, true)}</p>
            <p>518 N Santa Cruz Ave</p>
            <p>Los Gatos CA 95030</p>
          </div>
        ) : mlsAreaID === "SLN-C2401A" ? (
          <div className="return-address">
            <p>{filterBrokerage(brokerageName, true)}</p>
            <p>1300 First St. Suite 462</p>
            <p>Napa, CA 94559</p>
          </div>
        ) : (
          <div className="return-address">
            <p>{filterBrokerage(brokerageName, true)}</p>
            <p>{officeAddrLine1}</p>
            {officeAddrLine2 && <p>{officeAddrLine2}</p>}
            {useCommas2ndLine ? (
              <p>
                {officeCity}, {officeState} {officeZipcode}
              </p>
            ) : (
              <p>
                {officeCity} {officeState} {officeZipcode}
              </p>
            )}
          </div>
        )}
        <div>
          <div className="postage">
            <p>PRESORTED STANDARD</p>
            <p>U.S. POSTAGE PAID</p>
            <p>SAN JOSE, CA</p>
            <p>PERMIT NO 1785</p>
          </div>
        </div>
      </div>
    );
  }
}

export default FirstLeftHeader;
